import { Injectable } from '@angular/core';
import * as mobx from 'mobx-angular';
import { defaultDateFormat, TimeDisplays, TimeFormats } from '..';
import { B, F } from '../utils/fp-ts';
import { makeObservable } from '../utils/mobx';
import { BaseStore } from './base.store';
import { CurrentCompanyStore } from './current-company.store';

@Injectable({
  providedIn: 'root',
})
export class DateFormatStore extends BaseStore {
  @mobx.observable
  format = defaultDateFormat;

  @mobx.observable
  timeFormat = TimeFormats.HOURS_24;

  @mobx.observable
  timeDisplay = TimeDisplays.HH_MM;

  /**
   * Time format for date-fns.
   */
  @mobx.computed
  get fnsTimeFormat(): string {
    const timeDisplaySep = this.timeDisplay === TimeDisplays.HH_MM ? ':' : '.';

    return F.pipe(
      this.timeFormat === TimeFormats.HOURS_24,
      B.fold(
        () => `h${timeDisplaySep}mm a`,
        () => `H${timeDisplaySep}mm`,
      ),
    );
  }

  constructor(readonly currentCompanyStore: CurrentCompanyStore) {
    super();

    makeObservable(this);

    this.reaction(
      () => currentCompanyStore.currentCompany?.timeFormat || TimeFormats.HOURS_24,
      timeFormat => {
        this.timeFormat = timeFormat;
      },
      { fireImmediately: true },
    );

    this.reaction(
      () => currentCompanyStore.currentCompany?.timeDisplay || TimeDisplays.HH_MM,
      timeDisplay => {
        this.timeDisplay = timeDisplay;
      },
      { fireImmediately: true },
    );

    this.reaction(
      () => currentCompanyStore.currentCompany?.dateFormat || defaultDateFormat,
      dateFormat => {
        this.format = dateFormat;
      },
      { fireImmediately: true },
    );
  }
}
